import React from "react";
import styled from "styled-components";

interface IStyledSpinnerSVG {
  border: number;
  color: string;
  dashArray: number;
  dashOffset25: number;
  dashOffset97: number;
  height: number;
}

const SpinnerSVG = styled.svg<IStyledSpinnerSVG>`
  animation: rotate 2s linear infinite;
  width:  ${props => props.height + "px"};
  height: ${props => props.height + "px"};

  & circle {
    animation: dash 1.5s ease-in-out infinite both;
    stroke-dasharray: ${props => props.dashArray};
    stroke: ${props => (props.color ? props.color : "#505050")}
    transform-origin: 50% 50%;
  }

  @keyframes rotate {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }
  @keyframes dash {
    0%, 25% {
      stroke-dashoffset: ${props => props.dashOffset97};
      transform: rotate(0);
    }
    50%, 75% {
      stroke-dashoffset: ${props => props.dashOffset25};
      transform: rotate(45deg);
    }
    100%{
      stroke-dashoffset: ${props => props.dashOffset97};
      transform: rotate(360deg);
    }
  }
`;

interface ISVGSpinner {
  color?: string;
  height?: number;
  border?: number;
}

export const getDash = (radius: number, percentage: number): number =>
  Math.floor(2 * Math.PI * radius * (percentage / 100));

const SvgSpinner: React.FC<ISVGSpinner> = props => {
  const size: number = props.height ? props.height : 50;
  const border: number = props.border ? props.border : 5;
  const color: string = props.color ? props.color : "#505050";

  const dashArray: number = getDash(size / 2 - border, 100);
  const dashOffset25: number = getDash(size / 2 - border, 25);
  const dashOffset97: number = getDash(size / 2 - border, 97);

  return (
    <SpinnerSVG
      viewBox={"0 0 " + size + " " + size}
      height={size}
      border={border}
      color={color}
      dashArray={dashArray}
      dashOffset25={dashOffset25}
      dashOffset97={dashOffset97}
    >
      <circle cx={size / 2} cy={size / 2} r={size / 2 - border} fill="none" strokeWidth={border} />
    </SpinnerSVG>
  );
};

export default SvgSpinner;
